export const storeTourAttachments = (state, attachments) => {
  state.attachments = { ...attachments };
};
